import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=f2587b8a&scoped=true&"
import script from "./Stores.vue?vue&type=script&lang=ts&"
export * from "./Stores.vue?vue&type=script&lang=ts&"
import style0 from "./Stores.vue?vue&type=style&index=0&id=f2587b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2587b8a",
  null
  
)

export default component.exports